import React, { useState, useEffect } from "react";
import HeroDesktop from "./HeroDesktop";
import HeroMobile from "./HeroMobile";

const HeroPage = () => {
  return(
    <><HeroDesktop/></>
  )
};

export default HeroPage;
